module.exports = __webpack_public_path__ + "img/img3.24a4fb93.png";